module.exports = __webpack_public_path__ + "c4ae154d3a3eb819cc476127bd97caaf.MP3";